export { default } from './SimpleContentBlock.jsx'
